/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreateRequestBody = {
  /**
   * The origin from which the token will be used
   */
  embedOrigin: string;
  /**
   * Token expiration in seconds (max / default 3600)
   */
  expiresAfter?: number | undefined;
  /**
   * Optional free-form user identifier
   */
  userIdentifier?: string | undefined;
};

/** @internal */
export type CreateRequestBody$Outbound = {
  embed_origin: string;
  expires_after: number;
  user_identifier?: string | undefined;
};

/** @internal */
export const CreateRequestBody$outboundSchema: z.ZodMiniType<
  CreateRequestBody$Outbound,
  CreateRequestBody
> = z.pipe(
  z.object({
    embedOrigin: z.string(),
    expiresAfter: z._default(z.int(), 3600),
    userIdentifier: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      embedOrigin: "embed_origin",
      expiresAfter: "expires_after",
      userIdentifier: "user_identifier",
    });
  }),
);

export function createRequestBodyToJSON(
  createRequestBody: CreateRequestBody,
): string {
  return JSON.stringify(
    CreateRequestBody$outboundSchema.parse(createRequestBody),
  );
}
